export enum AuthorityStone {
  STONE_MANAGER = '16.1.1',
  STONE_DEVICE_CREATE = '16.2.1',
  STONE_DEVICE_EDIT = '16.2.2',
  STONE_DEVICE_DELETE = '16.2.3',
  STONE_ORDER_CREATE = '16.3.1',
}
